import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './setupAxiosInterceptor';
import { GoogleOAuthProvider } from '@react-oauth/google';

// REPLACE THIS STRING WITH YOUR ACTUAL GOOGLE CLIENT ID
const CLIENT_ID = "718048548517-73o4ddjqqbcqlaj8nn9dh2j01fuah0nn.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();